class CnRGWP {
    constructor(match_function,added_function,campaignId,giftId) {
        this.match_function = match_function;
        this.added_function = (added_function)?added_function:()=>{goCart.fetchAndOpenCart()};
        this.campaignId = campaignId;
        this.gwpId = giftId;
        document.addEventListener("CartUpdated",(event)=>{
			this.process(window.cart);
		});
    }
    process(cart) {
      console.error("processing");
        let giftIndex = -1;
        window.cart.items.forEach((item,index)=>{
            if (item.id==this.gwpId && item.properties['_cr_gwp']==this.campaignId) {
                giftIndex = index+1;
            }
        });
        if (this.match_function(cart)) {
          console.error("item matches!");
            if (giftIndex<0) {
                window.fetch("/cart/add.js",{
                    method:"POST",
                    body:JSON.stringify({id:this.gwpId,quantity:1,properties:{'_cr_gwp':this.campaignId}}),
                    headers:{"Content-type":"application/json"}
                }).then(response=>response.json())
                .then(json=>this.added_function())
                .catch(error=>console.error("error",error));
            }
        } else {
            if (giftIndex>=0) {
                let quantity = 0;
                window.fetch('/cart/change.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify({'quantity':quantity, 'line':giftIndex}),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => response.json())
                .then(() =>goCart.fetchAndOpenCart())
                .catch((error) => {});
            }
        }
    }
}